import { TFiltersProps, TSearchResult, TSortsProps } from './types'

export const DEF_SEARCH_RESULT: TSearchResult = {
    items: [],
    categories: [],
    meta: {
        total_price: 0,
        total_quantity: 0,
    },
    pagination: {
        limit: 0,
        page: 0,
        total: 0,
        totalPages: 0,
    },
}

// TODO: возмжоно не пригодится
export const DEF_FILTERS: TFiltersProps = {
    fromCreatedAt: null,
    fromUpdatedAt: null,
    toCreatedAt: null,
    toUpdatedAt: null,
    deleted_at: false,
}

// TODO: возмжоно не пригодится
export const DEF_SORTS: TSortsProps = {
    sort_by: 'id',
    sort_dir: 'asc',
}

export const DEF_PAGINATION_PAGE = 1
export const DEF_PAGINATION_LIMIT = 7
